// extracted by mini-css-extract-plugin
var _1 = "FormModalBody-moduleactions__oc3lH FormActions-moduleFormActions__WNNEs";
export { _1 as "actions" }
